// extracted by mini-css-extract-plugin
export var childrenContainer = "_br-0";
export var virtualScrollArea = "_br-1";